import { Storage } from "aws-amplify";

const JOTFORM_BASE_URL = "https://monitoredu.jotform.com/";

function getJotformUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${JOTFORM_BASE_URL}${path}`;
}

export async function resolveImageUrl(path) {
  if (!path) return "";

  if (path.startsWith("files/")) {
    console.log("[PodV2 API] Storage.get → start", { path });

    try {
      const url = await Storage.get(path, {
        level: "public",
        customPrefix: { public: "", protected: "", private: "" },
      });
      console.log("[PodV2 API] Storage.get → response", { path, url });
      return url;
    } catch (error) {
      console.error("[PodV2 API] Storage.get → error", { path, error });
      return "";
    }
  }

  const url = getJotformUrl(path);
  console.log("[PodV2 API] resolveImageUrl → jotform", { path, url });
  return url;
}
